import styled from 'styled-components';

export const DeliveryTypeWrapper = styled.div`
  display: flex;
  justify-content: end;
  margin-right: 30px;
  font-family: 'Be Vietnam', serif;
  font-style: normal;
  font-weight: 400;
  font-size: 17px;
  line-height: 13px;
  margin-top: 15px;

  p {
    color: #9cafaa;
    padding: 12px 15px;
    cursor: pointer;
    background: #333333;
    border-radius: 12px 12px 0px 0px;
  }

  .active {
    color: #fff;
    background: #ff8700;
    text-decoration: underline;
  }
`;
